<template>
  <button
    @click.prevent="topFunction()"
    class="scroll-top-button"
    title="Til toppen"
    ref="scrollTopButton"
  >
    <Arrow direction="up" />
  </button>
</template>

<script>
import { scrollAnimate } from '@/functions'
import Arrow from '@shared/Arrow/Arrow.vue'

export default {
  components: {
    Arrow,
  },
  data() {
    return {
      scrollToPosition: 0,
      showButtonPosition: 0,
      headerHeight: 0,
      topElement: null,
    }
  },
  props: {
    topElementId: { default: '', type: String },
  },
  methods: {
    init() {
      const headerTopPlacement = document.getElementById('headerTopPlacement')
      if (headerTopPlacement)
        this.headerHeight = headerTopPlacement.offsetHeight

      if (this.topElementId)
        this.topElement = document.getElementById(this.topElementId)

      if (this.topElement) {
        this.showButtonPosition =
          this.topElement.offsetTop +
          this.topElement.offsetHeight -
          this.headerHeight

        this.scrollToPosition = this.topElement.offsetTop - this.headerHeight
      }
    },
    scrollFunction() {
      if (
        document.body.scrollTop > this.showButtonPosition ||
        document.documentElement.scrollTop > this.showButtonPosition
      ) {
        this.$refs.scrollTopButton.style.display = 'block'
      } else {
        this.$refs.scrollTopButton.style.display = 'none'
      }
    },
    topFunction() {
      scrollAnimate(
        document.documentElement,
        this.scrollToPosition,
        'scrollTop',
        300
      )
      // Fix til Safari v12 og derunder (iphone 8 og ældre)
      scrollAnimate(document.body, this.scrollToPosition, 'scrollTop', 300)
    },
  },
  mounted() {
    this.init()

    window.onscroll = () => this.scrollFunction()
  },
}
</script>

<style lang="scss">
@import 'ScrollTopButton.scss';
</style>
